import React from "react";
import { DisplayDate } from '../../common/DisplayDate';

import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
  BooleanField,ShowButton,
  EditButton,
  DeleteButton,
  ImageField,
  Filter,
  ReferenceInput,
  SearchInput,
  SelectField,
} from "react-admin";
import { Authorizer } from "../../common/Authorizer";
import CDeleteButton from "../../common/CDeleteButton";

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <SearchInput
      variant="outlined"
      label="Policy Name"
      source="name~like"
      alwaysOn
    />
  </Filter>
);
export const DocumentTypeList = (props) => {
 
  //const propsObj = Authorizer(props);
  let propsObj = { ...props };
  if (propsObj.permissions) {
      let resourcename = `/${props.resource}`;
      let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
      propsObj.hasList =  false;
      propsObj.hasShow = false;
      propsObj.hasEdit =  false;
      propsObj.hasDelete = false;
      propsObj.hasCreate = false;
      propsObj.hasExport = false;
      if (myPermissions.length > 0) {
          let p = myPermissions[0];
          propsObj.hasList = (p.View == 1) ? true : false;
          propsObj.hasShow = (p.View == 1) ? true : false;
          propsObj.hasEdit = (p.Edit == 1) ? true : false;
          propsObj.hasDelete = (p.Delete == 1) ? true : false;
          propsObj.hasCreate = (p.Create == 1) ? true : false;
          propsObj.hasExport = (p.Export == 1) ? true : false;
          propsObj = { ...propsObj, ...p }
      }
  }

  return (
    <List  {...propsObj} exporter={propsObj.hasExport} bulkActionButtons={false} title="Document Type List" filters={<Filters />}  >
      <Datagrid rowClick={propsObj.hasEdit ? 'edit' :  false}>
        {propsObj.hasEdit && <EditButton />}
        {!propsObj.hasEdit && propsObj.hasShow && <ShowButton />}
        {propsObj.hasDelete && <CDeleteButton {...props}/>}
        
        <TextField source="name" label="Document Type Name " />
        

        <ReferenceField source="createdBy" reference="users" label="Created By"  link={false}>
                <TextField source="userName" />
            </ReferenceField>
            <DisplayDate  source="createdDate" label="Created Date" locales="fr-FR" />
            <ReferenceField source="modifyBy" reference="users" label="Updated By"  link={false}>
                <TextField source="userName" />
            </ReferenceField>
            <DisplayDate  source="modifyDate" label="Updated Date" locales="fr-FR" />
      </Datagrid>
    </List>
  );
};
